import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Visibility from "@material-ui/icons/Visibility";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import Buttons from "components/buttons/Pressed";
import axios from "axios";
import CloseIcon from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';
import TextField from "@material-ui/core/TextField";
import Delete from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import Zoom from "@material-ui/core/Zoom";
import InventoryContext from "context/inventory/inventoryContext";
import { GetGeneralPermissionForAction } from "utils/permissions/GetGeneralPermissionForAction";
import { Screen, Allow } from "global/constants";
import Cookies from "js-cookie";


const tooltipTheme = createMuiTheme({
    palette: {
        primary: {
            main: "#2c3e51"
        }
    },
    overrides: {
        MuiTooltip: {
            tooltip: {
                color: "white",
                fontSize: "1em",
                backgroundColor: "red",
                opacity: "0.7"
            }
        }
    }
});

const useStyles = makeStyles(theme => ({
    icons: {
        opacity: "0"
    },
    root: {
        flexGrow: 1,
    },
    iconReq: {
        marginLeft: "10px",
        opacity: "0",
        backgroundColor: "#6D6F71",
        color: "#FFFFFF;"
    },
    textField: {
        display: "flex",
    },
    textFieldCustum: {
        display: "flex",
        marginLeft: "10px"
    },
}));

const InventoryStatusTableActions = props => {
    const classes = useStyles();
    const [t] = useTranslation();
    const [openDelete, setOpenDelete] = useState(false);
    const [open, setOpen] = useState(false);
    const [openName, setOpenName] = useState(false);
    const [isModeView, setIsModeView] = useState(false);
    const [titleName, setTitle] = useState(t("GENERAL.requiredField"));
    const inventoryContext = useContext(InventoryContext);

    const {
        allStatus,
        deleteItemStatus,
        updateItemStatus,
    } = inventoryContext;

    const { item } = props;

    const [values, setValues] = React.useState({
        id: null,
        name: "",
        description: "",
        itensQtd: item.itensQtd,

    });

    const handleOpenDelete = () => {
        setOpenDelete(true);
    };
    const handleCloseDelete = () => {
        setOpenDelete(false);
    };
    const handleDelete = () => {
        deleteItemStatus(item.id);
        setOpenDelete(false);
    };
    const handleClose = () => {
        setOpen(false);
        clearRequiredMessage();
    };
    const clearRequiredMessage = () => {
        setOpenName(false);
    };
    const showRequiredFieldsMessage = () => {
        setOpenName(true);
    };

    const verifyEdit = () => {
        axios.get(process.env.REACT_APP_SERVER + `api/InventoryItemStatus/${item.id}`, {
            headers: {
                "Content-type": "application/json",
                "Authorization": "bearer " + (Cookies.get('auth-token') ? Cookies.get('auth-token') : "")
            }
        })
            .then(res => {
                var data = res.data
                setValues({
                    ...values,
                    id: data.id,
                    name: data.name ? data.name : "",
                    description: data.description ? data.description : "",
                    disableItem: true,
                });
                if (res.statusText === "OK") {
                    setOpen(true)
                    setIsModeView(false)
                } else {
                    deleteItemStatus(item.id);
                }
            })
            .catch(error => {
                deleteItemStatus(item.id);
            });
    }

    const verifyView = () => {
        axios.get(process.env.REACT_APP_SERVER + `api/InventoryItemStatus/${item.id}`, {
            headers: {
                "Content-type": "application/json",
                "Authorization": "bearer " + (Cookies.get('auth-token') ? Cookies.get('auth-token') : "")
            }
        })
            .then(res => {
                var data = res.data
                setValues({
                    ...values,
                    id: data.id,
                    name: data.name ? data.name : "",
                    description: data.description ? data.description : "",
                    disableItem: true
                });
                if (res.statusText === "OK") {
                    setOpen(true)
                    setIsModeView(true)
                } else {
                    deleteItemStatus(item.id);
                }
            })
            .catch(error => {
                deleteItemStatus(item.id);
            });
    }

    let data = [];
    data = allStatus;
    const handleChangeName = name => event => {
        if (name === "name") {
            clearRequiredMessage();
        }
        data = data.filter(item => item.name.trim().toLocaleLowerCase() === event.target.value.trim().toLocaleLowerCase());
        if (data.length !== 0 && event.target.value.trim().toLocaleLowerCase() !== item.name.trim().toLocaleLowerCase()) {
            setTitle(t("INVENTORY.nameStatusAlreadyTaken"));
            setOpenName(true);
        } else {
            setTitle(t("GENERAL.requiredField"));
        }
        setValues({ ...values, [name]: event.target.value });
    };

    const handleChange = name => event => {
        setValues({ ...values, [name]: event.target.value });
    };

    const handleSubmit = e => {
        if (!openName) {
            if (values.name.split("").filter(el => el !== " ").join("") !== "") {
                var obj = {
                    id: values.id,
                    name: values.name,
                    description: values.description,
                    disableItem: true
                };
                clearRequiredMessage();
                updateItemStatus(obj);
                setOpen(false);
                e.preventDefault();
            } else {
                showRequiredFieldsMessage();
            }
        } else showRequiredFieldsMessage();
    };

    return (
        <React.Fragment>
            {GetGeneralPermissionForAction(Screen.ITENS_STATUS, Allow.READ) &&
                <Tooltip title={t("GENERAL.view")} aria-label="details" placement="top">
                    <IconButton className={classes.icons} onClick={verifyView} >
                        <Visibility />
                    </IconButton>
                </Tooltip>
            }
            {GetGeneralPermissionForAction(Screen.ITENS_STATUS, Allow.EDIT) &&
                <Tooltip title="Editar" aria-label="edit" placement="top">
                    <IconButton className={classes.icons} onClick={verifyEdit} >
                        <Edit />
                    </IconButton>
                </Tooltip>
            }
            {GetGeneralPermissionForAction(Screen.ITENS_STATUS, Allow.DELETE) &&
                <Tooltip title="Deletar" aria-label="delete" placement="top">
                    <IconButton className={classes.icons} onClick={handleOpenDelete}>
                        <Delete />
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={openDelete}
                onClose={handleCloseDelete}
                aria-labelledby="form-dialog-title"
                msg="mensagem"
            >
                <DialogTitle className={classes.Title}>
                    {t("GENERAL.delete")} {t("INVENTORY.unavailabilityStatus")}
                    <IconButton style={{ float: "right", marginTop: -10, marginRight: -17 }} edge="end" color="inherit" onClick={handleCloseDelete} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {t("GENERAL.deleteStatusItem")}
                        <br></br>
                        <b>{item.name}</b>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Buttons
                        onClick={handleCloseDelete}
                        tipo="BN-noback"
                        conteudo={t("GENERAL.cancel").toUpperCase()}
                    />
                    <Buttons
                        onClick={handleDelete}
                        tipo="BN-blue"
                        conteudo={t("GENERAL.delete").toUpperCase()}
                    />
                </DialogActions>
            </Dialog>
            <Dialog
                open={open}
                fullWidth={true}
                maxWidth={"sm"}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                msg="mensagem"
            >
                <DialogTitle className={classes.TitleDialog}>
                    {isModeView ? t("INVENTORY.ViewItemStatus") : t("INVENTORY.updateItemStatus")}
                    <IconButton style={{ float: "right", marginTop: -10, marginRight: -17 }} edge="end" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <div className={classes.root}>
                            <Grid container>
                                <Grid item xs={12} sm={12}>
                                    <MuiThemeProvider theme={tooltipTheme}>
                                        <Tooltip
                                            TransitionComponent={Zoom}
                                            open={openName}
                                            title={titleName}
                                        >
                                            <TextField
                                                disabled={isModeView}
                                                className={classes.textField}
                                                label={t("INVENTORY.nameStatus") + "*"}
                                                value={values.name}
                                                onChange={handleChangeName("name")}
                                                margin="normal"
                                                inputProps={{
                                                    maxLength: 50
                                                }}
                                            />
                                        </Tooltip>
                                    </MuiThemeProvider>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    disabled={isModeView}
                                    multiline
                                    className={classes.textField}
                                    label={t("INVENTORY.descriptionBookCategory")}
                                    value={values.description ? values.description : isModeView ? "-" : ""}
                                    margin="normal"
                                    onChange={handleChange("description")}
                                    inputProps={{
                                        maxLength: 250
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    disabled
                                    className={classes.textField}
                                    label={t("INVENTORY.qtdItemCategory")}
                                    value={values.itensQtd}
                                    margin="normal"
                                    onChange={handleChange("booksItens")}
                                />
                            </Grid>
                        </div>
                    </DialogContentText>
                </DialogContent>
                {!isModeView ?
                    <DialogActions>
                        <Buttons
                            onClick={handleClose}
                            tipo="BN-noback"
                            conteudo={t("INVENTORY.cancel").toUpperCase()}
                        />
                        <Buttons
                            onClick={handleSubmit}
                            tipo="BN-blue"
                            conteudo={t("GENERAL.update").toUpperCase()}
                        />
                    </DialogActions>
                    :
                    <DialogActions>
                        <Buttons
                            onClick={handleClose}
                            tipo="BN-noback"
                            conteudo={t("INVENTORY.close").toUpperCase()}
                        />
                    </DialogActions>
                }
            </Dialog>
        </React.Fragment>
    )
};

export default InventoryStatusTableActions;